import React, { FC } from 'react'
import { Transition } from '@headlessui/react'
import classNames from 'classnames'
import { ResponsiveBackgroundImage } from '@/atoms/ResponsiveBackgroundImage'
import { BackgroundPosition } from '../types'

interface ResponsiveBackgroundContainerBannerProps {
  cloudinaryImgPath: string
  cloudinaryTabletImgPath?: string
  cloudinaryMobileImgPath?: string
  theaterBackgroundPosition?: BackgroundPosition
}

export const ResponsiveBackgroundContainerBanner: FC<ResponsiveBackgroundContainerBannerProps> = ({
  cloudinaryImgPath,
  cloudinaryMobileImgPath,
  cloudinaryTabletImgPath,
  theaterBackgroundPosition,
}) => {
  return (
    <Transition
      show
      as="div"
      enter="transition-opacity duration-1000"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-5500"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="pointer-events-none absolute left-0 top-0 z-0 m-0 min-h-[53vh] w-full overflow-y-hidden p-0 transition-opacity md:min-h-[55vh] lg:min-h-[105vh] xl:min-h-[110vh]">
        <div className="h-full w-full">
          <div className="block lg:hidden">
            <div className="block md:hidden">
              {/* Mobile image */}
              <ResponsiveBackgroundImage
                preBackgroundStyles=""
                src={cloudinaryMobileImgPath ?? cloudinaryImgPath}
                className="aspect-h-1 aspect-w-1 -mt-[2vh] block h-full w-full"
                transforms="g_face,c_fill"
              />
            </div>
            <div className="hidden md:block">
              {/* Tablet image */}
              <ResponsiveBackgroundImage
                preBackgroundStyles=""
                src={cloudinaryTabletImgPath ?? cloudinaryImgPath}
                className="bg-top-right aspect-h-9 aspect-w-16 block w-full"
                transforms="g_face,c_fill"
              />
            </div>
          </div>
          <div className="hidden pb-12 lg:block">
            {/* Desktop image */}
            <ResponsiveBackgroundImage
              preBackgroundStyles=""
              src={cloudinaryImgPath}
              className={classNames(
                'h-full w-full bg-right-top aspect-w-16 aspect-h-9 absolute top-0 right-0',
                theaterBackgroundPosition,
              )}
              transforms="g_face,c_fill"
            />
          </div>
        </div>
        {/* Left -> Right Gradient */}
        <div
          className={classNames('hidden md:block absolute inset-0 left-0 top-0 h-full w-full transition-opacity')}
          style={{
            background:
              'linear-gradient(90deg, rgba(21, 21, 21, 0.9) 0%, rgba(21, 21, 21, 0.7) 34.24%, rgba(21, 21, 21, 0) 69.25%)',
          }}
        />
        {/* Top -> Bottom Gradient */}
        <div
          className={classNames('absolute inset-0 left-0 top-0 h-full w-full transition-opacity')}
          style={{
            background: 'linear-gradient(180deg, #151515 0%, rgba(21, 21, 21, 0) 30%)',
          }}
        />
        {/* Bottom -> Top Gradient Mobile */}
        <div
          className={classNames('absolute inset-0 left-0 bottom-0 h-full w-full transition-opacity lg:hidden')}
          style={{
            background: 'linear-gradient(0deg, #141414 12.15%, rgba(21, 21, 21, 0) 75%)',
          }}
        />
        {/* Bottom -> Top Gradient Desktop */}
        <div
          className={classNames('absolute inset-0 left-0 bottom-0 h-full w-full transition-opacity hidden lg:block')}
          style={{
            background: 'linear-gradient(0deg, #141414 18.15%, rgba(21, 21, 21, 0) 70%)',
          }}
        />
      </div>
    </Transition>
  )
}
